<div class="home-page-card-content">
  <div class="home-page-card-content-title">{{ title | translate }}</div>
  <div class="home-page-card-content-container">
    <ng-content></ng-content>
  </div>
  <div></div>
</div>
